import React from 'react';
import styled from 'styled-components';
import LinkButton from './form-elements/LinkButton';
import moment from 'moment';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  flex-grow: 1;
  overflow: hidden;
`;

const TagWrapper = styled.div`
  display: flex;
  margin: 0 16px;
  overflow-x: scroll;
`;

const Tag = styled.span`
  background: #80225f;
  border-radius: 6px 6px 0px 0px;
  padding: 5px 32px;
  color: #ffffff;
  font-size: 0.8em;
  font-weight: 500;
  font-family: Montserrat, sans-serif;
  margin-right: 8px;
  white-space: nowrap;
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #e5e5e5;
  border-radius: 15px;
  padding: 16px;
  margin-bottom: 8px;
`;

const Title = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 1.5em;
  margin-bottom: 16px;
`;

const Date = styled.time`
  font-family: Montserrat, sans-serif;
  font-weight: 700;
`;

const ButtonWrapper = styled.div`
  display: flex;
`;

interface Props {
  pressRelease: {
    title: string;
    link: string;
    pub_date: string;
    dc_creator: string;
    category: string[];
  };
  type?: string;
}

const PressRelease: React.FC<Props> = function (props) {
  const { pressRelease, type = 'post' } = props;
  const { title, link, pub_date, dc_creator, category } = pressRelease;

  return (
    <Wrapper>
      <TagWrapper>
        {category.map(cat => (
          <Tag>{cat}</Tag>
        ))}
      </TagWrapper>
      <MainWrapper>
        <Title>{title}</Title>
        <Date>{moment(pub_date).format('LL')}</Date>
      </MainWrapper>
      <ButtonWrapper>
        <LinkButton
          buttonType="outline"
          buttonText="Read More"
          link={`/${type}${pressRelease.link}`}
        />
      </ButtonWrapper>
    </Wrapper>
  );
};

export default PressRelease;
